// extracted by mini-css-extract-plugin
export var animatedSkeletonBlock = "_2d-1";
export var movingGradient = "_2d-4";
export var movingGradientBlock = "_2d-2";
export var skeleton = "_2d-0";
export var skeletonText = "_2d-3";